import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userSearchQueryPlaceholder'
})
export class UserSearchQueryPlaceholderPipe implements PipeTransform {

  transform(value: string): string {
    switch (value) {
      case 'card':
        return 'کارت بانکی';
      case 'iban':
        return 'شماره شبا';
      case 'userID':
        return 'شناسه‌کاربری';
      case 'email':
        return 'ایمیل';
      case 'phone':
        return 'شماره تلفن';
      case 'nationalID':
        return 'کدملی';
      default:
        return 'جستجو بر اساس';
    }
  }

}
